import React, { useState, useEffect, useContext } from 'react';
import { Link } from "react-router-dom";
import { createMuiTheme, Slide, Container, Dialog, Toolbar, Typography, Fab, CssBaseline, TextField, Tooltip, Backdrop, CircularProgress, Grid, AppBar } from '@material-ui/core';
import { makeStyles } from "@material-ui/core/styles";
import { ThemeProvider } from '@material-ui/styles';
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace';
import AddIcon from '@material-ui/icons/Add';
import DeleteIcon from '@material-ui/icons/Delete';
import FormatListBulletedIcon from '@material-ui/icons/FormatListBulleted';
import DashboardIcon from '@material-ui/icons/Dashboard';
import PostAddIcon from '@material-ui/icons/PostAdd';
import styles from "../../../jss/material-dashboard-react/views/dashboardStyle.js";
import { GlobalTheme } from '../../../layouts/theme';
import { Theme } from '../../contexts/themeContext';
import { HttpService } from "../../../apiAuthorization/httpService";
import Card from "../../card/card.js";
import CardBody from "../../card/cardBody.js";
import UserAdd from "../user/userAdd";
import UserPOSAccountList from "../user/userPOSAccountList";
import UserSettingMenu from "../user/userSettingMenu";
import UserModuleList from "../user/userModuleList";
import AlertDialog from '../../common/alertDialog';
import ConfirmDialog from '../../common/confirmDialog';
import SmallMenu from '../../header/smallMenu';
import StatusIcon from '../../common/statusIcon';

const useStyles = makeStyles(styles);
const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

export default function UserList(props) {
    const classes = useStyles();
    const { theme } = useContext(Theme);
    const [id, setId] = useState(0);
    const [users, setUsers] = useState([]);
    const [appUsers, setAllUsers] = useState([]);
    const [filteredUsers, setFilteredUsers] = useState([]);
    const [unassignedUsers, setUnassignedUsers] = useState([]);
    const [recordToBeEdit, setRecordToBeEdit] = useState([]);
    const [userAddOpen, setUserAddOpen] = useState(false);
    const [userPOSAccountOpen, setUserPOSAccountOpen] = useState(false);
    const [userSettingOpen, setUserSettingOpen] = useState(false);
    const [userModuleOpen, setUserModuleOpen] = useState(false);
    const [confirmOpen, setConfirmOpen] = useState(false);
    const [alertOpen, setAlertOpen] = React.useState(false);
    const [severity, setSeverity] = React.useState('');
    const [errorMessage, setErrorMessage] = React.useState('');
    const [backDrop, setBackDrop] = useState(true);
    const currentTheme = theme ? createMuiTheme(GlobalTheme[theme]) : createMuiTheme(GlobalTheme[localStorage.getItem("theme")]);

    const rowStyle = (rowIndex) => {
        return { color: currentTheme.text, background: rowIndex % 2 === 0 ? '' : currentTheme.alternateGridRow };
    };

    const alertClose = () => {
        setAlertOpen(false);
    };

    const confirmClose = () => {
        setConfirmOpen(false);
    };

    const closeUserAdd = () => {
        setUserAddOpen(false);
    };

    const closeUserPOSAccount = () => {
        setUserPOSAccountOpen(false);
    };

    const openUserPOSAccount = (item) => {
        setUserPOSAccountOpen(true);
        setRecordToBeEdit(item);
    };

    const openUserSetting = (item) => {
        setUserSettingOpen(true);
        setRecordToBeEdit(item);
    };

    const closeUserSetting = () => {
        setUserSettingOpen(false);
    };

    const openUserModule = (item) => {
        setUserModuleOpen(true);
        setRecordToBeEdit(item);
    };

    const closeUserModule = () => {
        setUserModuleOpen(false);
    };

    const addUser = () => {
        setUserAddOpen(true);
    };

    const updateList = (item) => {
        if (item !== null) {
            const data = appUsers;
            data.push(item);
            setAllUsers(data);
            setFilteredUsers(data);
            const unassignedData = unassignedUsers;
            let index = unassignedData.findIndex(user => user.userName === item.userName);
            unassignedData.splice(index, 1);
            setUnassignedUsers(unassignedData);
        }
    };

    const deleteUserConfirm = (id) => {
        setId(id);
        setConfirmOpen(true);
    };

    const deleteUser = () => {
        setConfirmOpen(false);
        setBackDrop(true);
        HttpService.post('/User/DeleteAppUser', { AppUserId: id })
        .then((result) => {
            if (result.error) {
                setErrorMessage(result.message);
                setSeverity('error');
                setAlertOpen(true);
            }
            else {
                const data = appUsers.filter(user => user.id !== id);
                setFilteredUsers(data);
                setAllUsers(data);
                const unassignedData = unassignedUsers;
                let index = appUsers.findIndex(user => user.id === id);
                unassignedData.push(appUsers[index]);
                setUnassignedUsers(unassignedData);
            }
            setBackDrop(false);
        },
        (error) => {
            console.log(error);
        });
    };

    const filterData = (searchtext) => {
        if (searchtext !== "") {
            let data = appUsers.filter(user => user.userName.toLowerCase().includes(searchtext.toLowerCase()) || user.lastName.toLowerCase().includes(searchtext.toLowerCase()));
            setFilteredUsers(data);
        }
        else {
            setFilteredUsers(appUsers);
        }
    };

    const getAllUsers = () => {
        HttpService.post('/User/GetAllAppUsers', null)
        .then((result) => {
            if (result.data) {
                setAllUsers(result.data);
                setFilteredUsers(result.data);
                setBackDrop(false);
            }
        },
        (error) => {
            console.log(error);
        });
    };

    const getUsers = () => {
        HttpService.post('/User/GetUsers', null)
        .then((result) => {
            setUsers(result.data);
        },
        (error) => {
            console.log(error);
        });
    };

    useEffect(() => {
        getAllUsers();
        getUsers();
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        if (appUsers.length > 0 && users.length > 0) {
            let aUsers = [];
            let itemIndex = -1;
            for (let index = 0; index < users.length; index++) {
                let aUser = users[index];
                if (aUser && aUser.userName) {
                    itemIndex = appUsers.findIndex(user => user.userName === aUser.userName);
                    if (itemIndex === -1)
                        aUsers.push(aUser);
                }
            }
            setUnassignedUsers(aUsers);
        }
    }, [appUsers, users]);

    const fetchData = () => {
        return (
            <React.Fragment>
                <ThemeProvider theme={currentTheme}>
                    <CssBaseline />
                    <Backdrop className={classes.backdrop} id="userListBackdrop" open={backDrop}>
                        <CircularProgress color="inherit" />
                    </Backdrop>
                    <Dialog zindex="100" fullScreen open={userAddOpen} onClose={closeUserAdd} TransitionComponent={Transition}>
                        <UserAdd parentCallback={closeUserAdd}
                            refreshGrid={updateList}
                            users={unassignedUsers}
                        />
                    </Dialog>
                    <Dialog zindex="100" fullScreen open={userPOSAccountOpen} onClose={closeUserPOSAccount} TransitionComponent={Transition}>
                        <UserPOSAccountList parentCallback={closeUserPOSAccount}
                            model={recordToBeEdit}
                        />
                    </Dialog>
                    <Dialog zindex="100" fullScreen open={userSettingOpen} onClose={closeUserSetting} TransitionComponent={Transition}>
                        <UserSettingMenu parentCallback={closeUserSetting}
                            model={recordToBeEdit}
                        />
                    </Dialog>
                    <Dialog zindex="100" fullScreen open={userModuleOpen} onClose={closeUserModule} TransitionComponent={Transition}>
                        <UserModuleList parentCallback={closeUserModule}
                            model={recordToBeEdit}
                        />
                    </Dialog>
                    <Container maxWidth="xl" style={{ height: '95%' }} className={props.styles}>
                        <AppBar style={{ background: currentTheme.primary, color: currentTheme.color }}>
                            <Toolbar>
                                <Link to="/"><KeyboardBackspaceIcon /></Link>
                                <Grid container direction="row" alignItems="center">
                                    <Grid item>
                                        <Typography variant="h6" className={classes.title}>&nbsp;Users List</Typography>
                                    </Grid>
                                    <Grid item>
                                        <StatusIcon />
                                    </Grid>
                                </Grid>
                                <Grid container justify="flex-end">
                                    <Fab style={{ background: currentTheme.secondary, color: "white" }} size="small" aria-label="add" onClick={addUser}>
                                        <AddIcon />
                                    </Fab>
                                    <SmallMenu modified={false} />
                                </Grid>
                            </Toolbar>
                        </AppBar>
                        <Card color="primary" style={{ height: '100%', background: currentTheme.background }}>
                            <CardBody style={{ color: currentTheme.text, marginTop: "50px" }}>
                                <TextField style={{ width: "300px" }}
                                    label="Search By User Name/Last Name"
                                    placeholder="Search By User Name/Last Name"
                                    variant="outlined"
                                    size="small"
                                    onChange={e => filterData(e.target.value)}
                                />
                                <div className="react-bootstrap-table" style={{ overflowY: "auto", scrollBehavior: "smooth", position: "absolute", top: "70px", bottom: "15px", left: "15px", right: "15px" }}>
                                    <table className="table table-hover table-bordered">
                                        <thead>
                                            <tr>
                                                <th style={{ color: currentTheme.headerColor, background: currentTheme.headerBackground, width: "50px" }}>#</th>
                                                <th style={{ color: currentTheme.headerColor, background: currentTheme.headerBackground }}>User Name</th>
                                                <th style={{ color: currentTheme.headerColor, background: currentTheme.headerBackground }}>First Name</th>
                                                <th style={{ color: currentTheme.headerColor, background: currentTheme.headerBackground }}>Middle Name</th>
                                                <th style={{ color: currentTheme.headerColor, background: currentTheme.headerBackground }}>Last Name</th>
                                                <th style={{ color: currentTheme.headerColor, background: currentTheme.headerBackground }}>User Group</th>
                                                <th style={{ color: currentTheme.headerColor, background: currentTheme.headerBackground }}></th>
                                            </tr>
                                        </thead>
                                        <tbody className="text-capitalize">
                                            {filteredUsers?.map((item, index) => (
                                                <tr key={index}>
                                                    <td style={rowStyle(index)}>{index + 1}</td>
                                                    <td style={rowStyle(index)}>{item.userName}</td>
                                                    <td style={rowStyle(index)}>{item.firstName}</td>
                                                    <td style={rowStyle(index)}>{item.middleName}</td>
                                                    <td style={rowStyle(index)}>{item.lastName}</td>
                                                    <td style={rowStyle(index)}>{item.userGroup}</td>
                                                    <td style={rowStyle(index)}>
                                                        <Tooltip title="Delete" arrow>
                                                            <DeleteIcon style={{ color: currentTheme.secondary, cursor: 'pointer', float: 'right' }} onClick={() => deleteUserConfirm(item.id)} />
                                                        </Tooltip>
                                                        <Tooltip title="Assign Modules" arrow>
                                                            <DashboardIcon style={{ color: currentTheme.secondary, cursor: 'pointer', float: 'right' }} onClick={() => openUserModule(item)} />
                                                        </Tooltip>
                                                        <Tooltip title="Assign Settings" arrow>
                                                            <FormatListBulletedIcon style={{ color: currentTheme.secondary, cursor: 'pointer', float: 'right' }} onClick={() => openUserSetting(item)} />
                                                        </Tooltip>
                                                        <Tooltip title="POS Settings" arrow>
                                                            <PostAddIcon style={{ color: currentTheme.secondary, cursor: 'pointer', float: 'right' }} onClick={() => openUserPOSAccount(item)} />
                                                        </Tooltip>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                                <ConfirmDialog open={confirmOpen} close={confirmClose} onConfirm={deleteUser}
                                    title="Delete User" message="Are you sure you want to delete the selected User?" />
                                <AlertDialog open={alertOpen} close={alertClose} message={errorMessage} severity={severity} />
                            </CardBody>
                        </Card>
                    </Container>
                </ThemeProvider>
            </React.Fragment>
        );
    }

    let content = fetchData();
    return (
        <>
            {content}
        </>
    );
}
